import styled from 'styled-components';
import { Button } from 'antd';

import { ACCENT } from '../../../config/theme';

export default styled(Button).attrs({
  className: 'icon-btn',
  iconSize: props => props.iconSize || 20,
})`
  &.ant-btn {
    padding: ${props => props.iconSize / 2}px;
    font-size: ${props => props.iconSize}px;
    color: ${ACCENT};
    line-height: normal;
    border: none;

    &:hover {
      border: none !important;
    }

    &[data-preview-mode='true'] {
      background: transparent;

      &:disabled {
        border: none !important;
      }
    }

    i {
      /* Centralize the icon in the .ant-btn container */
      margin-left: ${props => `calc(50% - ${props.iconSize / 2}px)`};
    }
  }
`;
